export default "__VITE_ASSET__BmOO0f4V__"